import styled from "styled-components/macro";

export const Table = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  color: "#454E4F",
  [theme.breakpoint.lg()]: {},
}));

export const Row = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  padding: "8px 4px",

  "&:first-child": {
    backgroundColor: "#f1f3f4",
    alignItems: "center",
  },

  "&:not(:first-child)": {
    borderBottom: `1px solid ${theme.color.line.medium}`,

    "div:first-child": {
      fontWeight: "bold",
      paddingRight: "16px",
    },
  },
}));

export const Column = styled.div(({ theme }) => ({
  padding: "0 4px",
  flexBasis: 0,
  flexGrow: 1,
}));
